import { Company } from './company';
import type { PlatformRole } from './platform-role';
import { Team } from './teams';

export type User = {
  uuid: string;
  email: string;
  name: string;
  profilePicture: string;
  coachDataSharingEnabled?: boolean;
  bookingUrl?: string | null;
  isPerformancePartner?: boolean;
  credits: number;
  isInTrialMode: boolean;
  isZoomConnected: boolean;
  meetingsZoomConnectionState?: 'connected' | 'reauth_required' | null;
  isAlphaUser: boolean;
  canAccessPlatformAdmin: boolean;
  platformRole?: PlatformRole | null;
  connectedCalendars: string[];
  // Multi-tenant fields
  role: UserRole;
  company?: Company;
  companyId?: number;
  teams?: Team[];
  isChannelPartnerAdmin?: boolean;
  isCompanyAdmin?: boolean;
  isCompanyManager?: boolean;
  invitationSentAt?: string;
  invitationAcceptedAt?: string;
};

export type UpdateUserRoleRequest = {
  userUuid: string;
  role: UserRole;
  reason?: string;
};

export type BulkUserOperationRequest = {
  companyUuid: string;
  operation: string;
  userUuids: string[];
  role?: UserRole;
  reason?: string;
};

export type DeactivateUserRequest = {
  userUuid: string;
  reason?: string;
};

export type BulkUserOperationResponse = {
  success: boolean;
  processedCount: number;
  errors: Array<{ userUuid: string; error: string }>;
};

export enum ConnectedCalendar {
  GOOGLE_CALENDAR = 'google_calendar',
  MICROSOFT_OUTLOOK = 'microsoft_outlook',
}

export enum UserRole {
  CHANNEL_PARTNER_ADMIN = 'channel_partner_admin',
  COMPANY_ADMIN = 'company_admin',
  COMPANY_MANAGER = 'company_manager',
  COMPANY_MEMBER = 'company_member',
}
